"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.add = void 0;
exports.add = {
    path: "M15.8333 10.8333H10.8333V15.8333H9.16666V10.8333H4.16666V9.16663H9.16666V4.16663H10.8333V9.16663H15.8333V10.8333Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
